import React from 'react';
import PageShell from './PageShell';
import { mountainsLayered } from '../mock';
import { Check } from 'lucide-react';
import { useLang } from '../i18n/LanguageContext';

const AttivitaPage = () => {
  const { t } = useLang();
  const sectors = t('sectors');
  const steps = t('activity.steps');
  return (
    <PageShell eyebrow={t('activity.eyebrow')} title={t('activity.title')} image={mountainsLayered}>
      <section className="py-24 bg-white">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <p className="text-[#475569] leading-relaxed text-lg">{t('activity.intro')}</p>

          <h3 className="mt-14 text-3xl font-semibold text-[#0b2545]" style={{ fontFamily: "'Barlow Condensed', 'Oswald', sans-serif" }}>
            {t('activity.sectorsTitle')}
          </h3>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {sectors.map((s) => (
              <div key={s} className="p-5 bg-[#f1f5f9] border-l-2 border-[#c53114] flex items-center gap-3">
                <Check className="text-[#c53114]" size={18} />
                <span className="text-[#0b2545] font-medium">{s}</span>
              </div>
            ))}
          </div>

          <h3 className="mt-16 text-3xl font-semibold text-[#0b2545]" style={{ fontFamily: "'Barlow Condensed', 'Oswald', sans-serif" }}>
            {t('activity.approachTitle')}
          </h3>
          <ol className="mt-8 space-y-6">
            {steps.map((step, i) => (
              <li key={step.t} className="flex items-start gap-6">
                <div className="w-14 h-14 flex items-center justify-center bg-[#0b2545] text-white text-2xl font-semibold flex-shrink-0" style={{ fontFamily: "'Barlow Condensed', 'Oswald', sans-serif" }}>
                  {String(i + 1).padStart(2, '0')}
                </div>
                <div>
                  <h4 className="text-xl font-semibold text-[#0b2545]">{step.t}</h4>
                  <p className="mt-1 text-[#475569] leading-relaxed">{step.d}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>
    </PageShell>
  );
};

export default AttivitaPage;
